import {TableSettings} from '../../interfaces/table-setting.interface';
import {PageableDTO} from '../../openapi/fakturierung-openapi';


export enum FakturierungsbelegColumn {
  Status = 'status',
  BelegArt = 'belegart',
  Faelligkeit = 'faelligkeit',
  Belegnummer = 'belegnummer',
  Kunde = 'kunde',
  Belegdatum = 'belegdatum',
  Nettobetrag = 'nettobetrag',
  Bruttobetrag = 'bruttobetrag',
  Versandstatus = 'versandstatus',
  Actions = 'actions',
}

export interface FakturierungsbelegTableState {
  displayedIds: string[];
  tableSettings: TableSettings;
  pageableDto: PageableDTO;
  totalPages: number;
  isLoaded: boolean;
}
